import contracts from "./contracts";
import chats from "./chats";

export default {
  namespaced: true,
  modules: {
    contracts,
    chats,
  },
};
